import React, { useState } from "react";
import { IAcademicsMenuCoursesData } from "../../exports/interfaces";
import { Link } from "react-router-dom";

const DegreeTile = (props: {
  title: string;
  description: string;
  degrees: IAcademicsMenuCoursesData[];
  icon: any;
  image: string;
  index: number;
  start_background_color: string;
  end_background_color: string;
}) => {
  const [isHovered, setIsHovered] = useState<number | null>(null);

  return (
    <div
      style={{
        width: "100%",
        height: "400px",
        // border: `1px solid ${props.start_background_color}`,
        borderRadius: "10px",
        overflow: "hidden",
        position: "relative",

        /* background image */
        backgroundImage:
          isHovered !== null
            ? `linear-gradient(
  130deg,
  rgba(255, 255, 255, 0.4) 0%,
  rgba(0, 0, 0, 0.8) 100%
),
  url(${process.env.REACT_APP_cmsUrl}${props.image})`
            : `
  linear-gradient(
  130deg,
  ${props.end_background_color}DD 0%,
  ${props.start_background_color} 100%
),
  url(${process.env.REACT_APP_cmsUrl}${props.image})
`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "0px",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          // background:
          //    "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.7))",
          zIndex: 1,
        }}
      />
      <div
        style={{
          width: "100%",
          borderRadius: "10px 10px 0px 0px",
        }}
      ></div>
      <div
        style={{
          position: "relative",
          zIndex: 2,
          padding: "20px",
          fontSize: "14px",
          lineHeight: "20px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "75px" }}>
          <i
            className={props.icon}
            style={{
              color: "#fff",
              fontSize: "36px",
              marginBottom: "-50px",
            }}
          ></i>
          <h5
            style={{
              color: "#fff",
              lineHeight: "1.6",
            }}
          >
            {props.title}
          </h5>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {props.degrees?.map((degree, i) => {
            const hovered = isHovered === i;

            return (
              <Link key={i} to={`/sast/${degree.program_name}/${degree.name}`}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                  }}
                  onMouseEnter={() => setIsHovered(i)}
                  onMouseLeave={() => setIsHovered(null)}
                >
                  <svg
                    style={{ flexShrink: 0, marginTop: "4px" }}
                    width="16"
                    height="16"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.564 4.70161L4.42188 18.8438"
                      stroke={hovered ? "#f58466" : "#fff"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.5654 13.5341C18.5654 13.5341 19.7299 5.85989 18.5654 4.69528C17.4008 3.53067 9.72656 4.69531 9.72656 4.69531"
                      stroke={hovered ? "#f58466" : "#fff"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span
                    style={{
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: hovered ? "#f58466" : "#fff",
                    }}
                  >
                    {degree.name}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DegreeTile;
